import Decimal from "decimal.js";

export const formatNumber = (value, decimalPlaces = 4, mode = "round") => {
  if (value === null || value === undefined) return "-";

  const roundingMap = {
    up: Decimal.ROUND_UP,
    down: Decimal.ROUND_DOWN,
    truncate: Decimal.ROUND_DOWN,
    round: Decimal.ROUND_HALF_UP,
  };

  const rounding = roundingMap[mode] ?? Decimal.ROUND_HALF_UP;

  const d = new Decimal(value);
  return d.toDecimalPlaces(decimalPlaces, rounding).toFixed(decimalPlaces);
};

export const round2 = (value) => {
  const n = Number(value || 0);
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

export const formatDigits = (value) => {
  return round2(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
